import { getDinamicCSSTypes } from '../../../../helpers/dinamicTyping';

const MAX_HEIGHT_VH = '100vh';
const MAX_HEIGHT_PERTCENTAGE = '100%';

export const landingMainContainerStyle = getDinamicCSSTypes({
  maxHeigthPercentage: { height: MAX_HEIGHT_PERTCENTAGE },
  maxHeightVH: { height: MAX_HEIGHT_VH },
  mainContainerDesktop: {
    height: MAX_HEIGHT_VH,
    overflow: 'hidden',
  },
  mainContainerMobile: {
    height: MAX_HEIGHT_VH,
  },
  imageContainer: {
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    maxHeight: '100%',
    objectFit: 'cover',
    overflow: 'hidden',
  },
  appbarContainer: {
    boxShadow: '0 4px 4px 0 rgb(0 37 122 / 10%)',
    top: 0,
    paddingTop: '11px',
    alignItems: 'center',
    bottom: 'auto',
    backgroundColor: 'white',
    height: '61px',
  },
  appbarLogo: {
    height: '34px',
    marginLeft: 1,
  },
  containerWithAppbar: {
    marginTop: '61px',
  },
});
